
	$('.l-header-menu__item').hover(function() {
		$(this).find('.menu_content__wrap').stop().slideDown('fast');
	}, function() {
		$(this).find('.menu_content__wrap').stop().slideUp('fast');
	});



  $('#qa1').hover(function() {
    $(".qa1_ttl").addClass('on');
		$(".qa2_ttl").removeClass('on');
		$(".qa3_ttl").removeClass('on');

    $(".qa1").addClass('open');
		$(".qa2").removeClass('open');
		$(".qa3").removeClass('open');
	});


  $('#qa2').hover(function() {
    $(".qa1_ttl").removeClass('on');
		$(".qa2_ttl").addClass('on');
		$(".qa3_ttl").removeClass('on');

    $(".qa1").removeClass('open');
		$(".qa2").addClass('open');
		$(".qa3").removeClass('open');
	});


  $('#qa3').hover(function() {
    $(".qa1_ttl").removeClass('on');
		$(".qa2_ttl").removeClass('on');
		$(".qa3_ttl").addClass('on');

    $(".qa1").removeClass('open');
		$(".qa2").removeClass('open');
		$(".qa3").addClass('open');
	});